/**
 * Caution: Consider this file when using react-scripts
 *
 * You may delete this file and its occurrences from the project filesystem if you are using GatsbyJS or NextJS version
 */
import React from 'react';
import { Router, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { QueryParamProvider } from 'use-query-params';
import Highcharts from 'highcharts';
import HighchartsExporting from 'highcharts/modules/exporting';
import HighchartsExportData from 'highcharts/modules/export-data';
import Routes from 'Routes';
import { colors } from 'theme/highchart';
import i18next from 'i18next';

import 'react-lazy-load-image-component/src/effects/opacity.css';
import 'leaflet/dist/leaflet.css';
import 'assets/css/index.css';
import 'assets/fonts/stylesheet.css';

import 'swiper/swiper-bundle.min.css';
import 'aos/dist/aos.css';
import { useTheme, useMediaQuery } from '@material-ui/core';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const browserHistory = createBrowserHistory();
if (typeof Highcharts === 'object') {
  Highcharts.defaultOptions.colors = colors;
  HighchartsExporting(Highcharts);
  HighchartsExportData(Highcharts);
}

const App = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  });
  const LANG_PREFIX = isSm ? 'HIGHCHARTS.MOBILE' : 'HIGHCHARTS';
  const HC_FORMATTERS_DIGIT = 1;
  const HC_FORMATTERS = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: i18next.t(`${LANG_PREFIX}.THOUSAND`) },
    { value: 1e6, symbol: i18next.t(`${LANG_PREFIX}.MILLION`) },
    { value: 1e9, symbol: i18next.t(`${LANG_PREFIX}.BILLION`) },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ];

  if (typeof Highcharts === 'object') {
    Highcharts.setOptions({
      yAxis: {
        labels: {
          formatter: function() {
            const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            const value = this.value;
            const usedFormatter = HC_FORMATTERS.slice()
              .reverse()
              .find(fr => value >= fr.value);

            if (usedFormatter) {
              return (
                (value / usedFormatter.value)
                  .toFixed(HC_FORMATTERS_DIGIT)
                  .replace(rx, '$1') +
                ' ' +
                usedFormatter.symbol
              );
            }

            return value;
          },
        },
      },
      lang: {
        numericSymbols: [
          i18next.t(`${LANG_PREFIX}.THOUSAND`),
          i18next.t(`${LANG_PREFIX}.MILLION`),
          i18next.t(`${LANG_PREFIX}.BILLION`),
          'T',
          'P',
          'E',
        ],
      },
    });
  }

  return (
    <Router history={browserHistory}>
      <QueryParamProvider ReactRouterRoute={Route}>
        <Routes />
      </QueryParamProvider>
    </Router>
  );
};

export default App;
